import { IconProps } from '../icon';

export function InfoOdooCrmIcon(props: IconProps) {
  return (
    <svg
      id="crm"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="40"
      height="40"
      viewBox="0 0 40 40"
      {...props}
    >
      <defs>
        <clipPath id="clipPath">
          <rect
            id="Rectangle_157"
            data-name="Rectangle 157"
            width="40"
            height="40"
            fill="#41B883"
          />
        </clipPath>
      </defs>
      <g id="Groupe_304" data-name="Groupe 304" clipPath="url(#clipPath)">
        <g id="Groupe_303" data-name="Groupe 303">
          <g id="Groupe_302" data-name="Groupe 302" clipPath="url(#clipPath)">
            <g id="Groupe_301" data-name="Groupe 301" opacity="0.3">
              <g id="Groupe_300" data-name="Groupe 300">
                <g
                  id="Groupe_299"
                  data-name="Groupe 299"
                  clipPath="url(#clipPath)"
                >
                  <path
                    id="Tracé_101"
                    data-name="Tracé 101"
                    d="M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0"
                    fill="#41B883"
                  />
                </g>
              </g>
            </g>
            <path
              id="Tracé_102"
              data-name="Tracé 102"
              d="M262.232,130.431a2.249,2.249,0,0,1-1.522-.546,2.12,2.12,0,0,1,.016-3.037,2.177,2.177,0,0,1,1.507-.585,2.235,2.235,0,0,1,1.468.531,1.893,1.893,0,0,1,.64,1.546,1.95,1.95,0,0,1-.625,1.538,2.16,2.16,0,0,1-1.483.554m2.108,4.4v12.318a2.75,2.75,0,0,1-.609,1.936,2.017,2.017,0,0,1-1.546.656,1.925,1.925,0,0,1-1.522-.671,2.834,2.834,0,0,1-.585-1.92V134.958a2.737,2.737,0,0,1,.585-1.9,1.968,1.968,0,0,1,1.522-.64,2.041,2.041,0,0,1,1.546.64,2.479,2.479,0,0,1,.609,1.78"
              transform="translate(-242.233 -117.599)"
              fill="#41B883"
            />
          </g>
        </g>
      </g>
    </svg>
  );
}

export default InfoOdooCrmIcon;
